export default {
    search: 'ค้นหา',
    searchText: 'ค้นหาจากชื่อผู้เยี่ยมเยือน',
    exportPDF: 'ดาวน์โหลด PDF',
    exportExcel: 'ดาวน์โหลด Excel',
    visitorName: 'ชื่อผู้เยี่ยมเยือน',
    contact: 'ติดต่อ',
    contactNo: 'เบอร์โทรศัพท์',
    date: 'วันที่',
    time: 'เวลา',
    image: 'รูปภาพ',
    location: 'สถานที่',
    temp: 'อุณหภูมิ',
    somethingWrong: 'เกิดข้อผิดพลาด'
}
